export default {
      id: "icon--chevron-left-usage",
      viewBox: "0 0 7 13",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-left-usage",
      toString: function () {
        return this.url;
      }
    }